import React, { useEffect } from "react";
import './App.css';
import Footer2 from './Components/Footer/Footer2';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import { useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Privacypolicy from './Components/Privacypolicy/Privacypolicy';
import Aboutus from './Components/About/Aboutus';
import Layouts from './Components/Layout/Layouts';
import Pricelist from './Components/Price/Pricelist';
import Contactus from './Components/Contactus/Contactus';
import Chatbox from './Components/Chatbox/Chatbox'
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/layouts" element={<Layouts />} />
        <Route path="/pricelist" element={<Pricelist />} />
        <Route path="/disclaimer" element={<Privacypolicy />} />
      </Routes>
      <Footer2/>
      <Chatbox/>
    </Router>
  );
}

export default App;
